<template>
    <div class="sections">
        <div class="section1">
            <Navbar/>
        </div>
        <div class="section2">
            <router-view/>
        </div>
        <div class="section3"><Footer/></div>
    </div>
</template>
<script>
    import Navbar from '../shared/Navbar.vue';
    import Footer from '../shared/Footer.vue';
    export default{
        components:{
            Navbar,Footer
        }
    }
</script>
<style scoped>
    .sections{
        display: grid;
        grid-template-rows:auto 1fr auto;
        min-height: 100vh;
    }

    .section2{
        padding-top:2.4rem;
        padding-bottom:0.5rem;
        padding-left:0rem;
        padding-right:0rem;
    }
    .section1, .section3{
        background-color: var(--primary);
    }
</style>